const getNumbersToDisplay = (
  currentPage: number,
  totalMatchedPages: number
) => {
  switch (true) {
    case totalMatchedPages <= 6:
      return Array.from({ length: totalMatchedPages }, (_, i) => i + 1);
    case currentPage <= 4:
      return [1, 2, 3, 4, -1, totalMatchedPages];
    case currentPage >= totalMatchedPages - 3:
      return [
        1,
        -1,
        totalMatchedPages - 3,
        totalMatchedPages - 2,
        totalMatchedPages - 1,
        totalMatchedPages
      ];
    default:
      return [
        1,
        -1,
        currentPage - 1,
        currentPage,
        currentPage + 1,
        -2,
        totalMatchedPages
      ];
  }
};

export default getNumbersToDisplay;
